// @ts-nocheck
import React from 'react';
import { Badge } from '../../../components/ui/badge';
import type {
  CampaignType,
  DeploymentItemStatus,
  DeploymentStatus,
} from '../../../api/deploymentsApi';

interface StatusEntry {
  label: string;
  className: string;
}

const DEPLOYMENT_STATUS_MAP: Record<DeploymentStatus, StatusEntry> = {
  draft: { label: 'Brouillon', className: 'bg-gray-100 text-gray-700' },
  in_progress: { label: 'En cours', className: 'bg-blue-100 text-blue-700' },
  completed: { label: 'Terminé', className: 'bg-green-100 text-green-700' },
  completed_with_errors: {
    label: 'Terminé avec erreurs',
    className: 'bg-orange-100 text-orange-700',
  },
  cancelled: { label: 'Annulé', className: 'bg-red-100 text-red-700' },
};

const ITEM_STATUS_MAP: Record<DeploymentItemStatus, StatusEntry> = {
  pending: { label: 'En attente', className: 'bg-gray-100 text-gray-700' },
  created: { label: 'Créé', className: 'bg-green-100 text-green-700' },
  failed: { label: 'Échec', className: 'bg-red-100 text-red-700' },
  skipped: { label: 'Ignoré', className: 'bg-yellow-100 text-yellow-700' },
};

export const CAMPAIGN_TYPE_LABELS: Record<CampaignType, string> = {
  scheduled_integration: 'Intégration programmée',
  permanent_maintenance: 'Maintenance permanente',
};

const CAMPAIGN_TYPE_MAP: Record<CampaignType, StatusEntry> = {
  scheduled_integration: { label: CAMPAIGN_TYPE_LABELS.scheduled_integration, className: 'bg-indigo-100 text-indigo-700' },
  permanent_maintenance: { label: CAMPAIGN_TYPE_LABELS.permanent_maintenance, className: 'bg-teal-100 text-teal-700' },
};

const renderBadge = <K extends string>(
  map: Record<K, StatusEntry>,
  status: K
) => {
  const entry = map[status] ?? { label: String(status), className: 'bg-gray-100' };
  return <Badge className={entry.className}>{entry.label}</Badge>;
};

export const DeploymentStatusBadge = ({ status }: { status: DeploymentStatus }) =>
  renderBadge(DEPLOYMENT_STATUS_MAP, status);

export const DeploymentItemStatusBadge = ({
  status,
}: {
  status: DeploymentItemStatus;
}) => renderBadge(ITEM_STATUS_MAP, status);

export const CampaignTypeBadge = ({ type }: { type: CampaignType }) =>
  renderBadge(CAMPAIGN_TYPE_MAP, type);
